export default __webpack_public_path__ + "locales/uk-UA/InviteDialog.json?hash=e9c091f0132864958b087aee2a8b7756";